import React from "react";
import SideBySideLayout from "@components/SideBySideLayout";
import BGDesktop from "./img/bg-desktop.jpg";
import BGMobile from "./img/bg-mobile.jpg";
import "./style.scss";
import Button from "@components/Button";
import { useWindowSize } from "../../Helpers";

export default function AgeGate() {
  const { width } = useWindowSize();

  return (
    <SideBySideLayout
      position="top"
      bgImageDesktop={BGDesktop}
      bgImageMobile={BGMobile}
    >
      <div className="age-gate-content">
        <div className="inner-content">
          <div className="copy">
            <h1>
              Um diese Website <br /> besuchen zu dürfen,
              <br />
              <strong>musst du 18 Jahre oder älter sein.</strong>
            </h1>
          </div>
          <div className="buttons-wrapper">
            <Button
              btnClass={`yellow outline ${width >= 1020 ? "reversed" : ""} `}
              href={"/age-gate-failed"}
              action={() => {
                localStorage.setItem("age-gate", "failed");
              }}
            >
              Ich bin unter 18 Jahre alt
            </Button>
            <Button
              href={window.location.pathname.startsWith("/qrv/") ? window.location.pathname : "/"}
              action={() => {
                localStorage.setItem("age-gate", "success");
              }}
            >
              Ich bin 18 Jahre oder älter
            </Button>
          </div>
        </div>
      </div>
    </SideBySideLayout>
  );
}
